// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
/// <summary>
/// AccountOperationRequestMessage
/// </summary>
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let AccountOperationRequestMessage = function (fieldSet)
{
    this.Code = Message.CODE_ACCOUNT_OPERATION_REQUEST_MESSAGE;
    PFixMessage.call(this, fieldSet)
}
AccountOperationRequestMessage.prototype = Object.create(PFixMessage.prototype)

AccountOperationRequestMessage.prototype.assetId = function (assetId)
{
    this.setFieldValue(FieldsFactory.FIELD_ASSET_ID, assetId);
}

AccountOperationRequestMessage.prototype.setOperationType = function (operationType, serverMaxField)
{
    if (serverMaxField >= FieldsFactory.FIELD_OPERATION_TYPE2)
        this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE2, operationType);
    else
        this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE, operationType);
}

AccountOperationRequestMessage.prototype.setAccountId = function (accountId)
{
    this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
}

AccountOperationRequestMessage.prototype.setCounterId = function (counterId)
{
    if (counterId)  //#114179
        this.setFieldValue(FieldsFactory.FIELD_COUNTER_ID, counterId);
}

AccountOperationRequestMessage.prototype.setAmount = function (amount)
{
    this.setFieldValue(FieldsFactory.FIELD_AMOUNT, amount);
}

AccountOperationRequestMessage.prototype.setComment = function (comment)
{
    this.setFieldValue(FieldsFactory.FIELD_COMMENT, comment);
}


/// <summary>
/// AccountOperationConfirmMessage
/// </summary>
export var AccountOperationConfirmMessage = function (fieldSet)
{
    this.Code = Message.CODE_ACCOUNT_OPERATION_CONFIRM_MESSAGE;
    PFixMessage.call(this, fieldSet)
}

AccountOperationConfirmMessage.prototype.setOperationType = function (operationType, serverMaxField)
{
    if (serverMaxField >= FieldsFactory.FIELD_OPERATION_TYPE2)
        this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE2, operationType);
    else
        this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE, operationType);
}

AccountOperationConfirmMessage.prototype.setOrderId = function (orderId)
{
    this.setFieldValue(FieldsFactory.FIELD_ORDER_ID, orderId);
}

AccountOperationConfirmMessage.prototype.setCrossPrice = function (crossPrice)
{
    this.setFieldValue(FieldsFactory.FIELD_CROSS_PRICE, crossPrice);
}

AccountOperationConfirmMessage.prototype.setAmount = function (amount)
{
    this.setFieldValue(FieldsFactory.FIELD_AMOUNT, amount);
}

AccountOperationConfirmMessage.prototype.setMode = function (mode)
{
    this.setFieldValue(FieldsFactory.FIELD_MODE, mode);
}